// Author Shi Wen Long
// Date 2024-06-24 09:13:47

import * as model from "@/model/sithMes/stool/SithMesStool26StockModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesStool26Stock(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_STOOL_URL,
    })
    .buildStore()
